const FIELD_LABELS: Record<string, string> = { title: 'Bezeichnung', quantityMilli: 'Menge', unit: 'Einheit', unitPriceCents: 'Einzelpreis', discountBp: 'Rabatt', taxRate: 'USt.', taxCode: 'Steuer', description: 'Beschreibung' };

/**
 * Macht aus den Fehlern des Servers zu den Positionen eine Meldung, die sagt, was in welcher Position nicht stimmt, zum Beispiel „Position 1, Menge: Menge zu groß“.
 * Ohne Fehler an Positionen gibt es null zurück.
 */
export function lineErrorText(fields: Record<string, string>): string | null {
  for (const [key, message] of Object.entries(fields)) {
    const match = /^lines\.(\d+)\.(\w+)$/.exec(key);
    if (match) return `Position ${Number(match[1]) + 1}, ${FIELD_LABELS[match[2]!] ?? match[2]}: ${message}`;
  }
  const general = fields.lines;
  return general ?? (Object.keys(fields).some((k) => k.startsWith('lines')) ? 'Bitte prüfen Sie die Positionen: Jede braucht Bezeichnung, Menge, Einheit und Preis.' : null);
}
